<script lang="ts" setup>
import { computed } from 'vue'

const { offsetX = 0, offsetY = 0 } = defineProps<{ offsetX?: number; offsetY?: number }>()

const style = computed(() => ({
  '--offset-x': offsetX + 'px',
  '--offset-y': offsetY + 'px',
}))
</script>

<template>
  <Transition
    :enterActiveClass="$style.slideEnterActive"
    :leaveActiveClass="$style.slideLeaveActive"
    :enterFromClass="$style.slideEnterFrom"
    :leaveToClass="$style.slideLeaveTo"
    :style="style"
  >
    <slot />
  </Transition>
</template>

<style lang="scss" module>
.slideEnterActive,
.slideLeaveActive {
  transition:
    opacity 0.2s ease-in-out,
    transform 0.2s ease-in-out;
}

.slideEnterFrom,
.slideLeaveTo {
  transform: translateY(var(--offset-y)) translateX(var(--offset-x));
  opacity: 0;
}
</style>
